import { createAction } from '@reduxjs/toolkit';
import type { SavedSearch, SearchParameters } from 'lib-shared-types-api';

const prefix = 'search';

export const searchActions = {
  params: {
    update: createAction<Partial<SearchParameters>>(`${prefix}/params/update`),
  },

  savedSearch: {
    apply: createAction<SavedSearch>(`${prefix}/savedSearch/apply`),
    close: createAction(`${prefix}/savedSearch/close`),
  },
};
